import type { CropState } from "./types"
import { COLORS } from "../../../styles/variables"
import { alpha } from "@mui/material"

const CROP_OVERLAY_SPREAD_PX = 4000

const Z_INDEX_CROP_FRAME = 5
const Z_INDEX_RESIZE_HANDLE = 10
const RESIZE_HANDLE_OFFSET = -8
const RESIZE_HANDLE_SIZE = 18

const ruleOfThirdsBorder = `1px solid ${alpha(COLORS.WHITE, 0.2)}`

export const modalPaperStyle = {
  bgcolor: COLORS.WHITE,
  p: 3,
  borderRadius: 2,
  outline: "none",
  maxWidth: "90vw",
}

export const containerStyle = {
  position: "relative",
  bgcolor: COLORS.WHITE,
  userSelect: "none",
  lineHeight: 0,
  overflow: "hidden",
  borderRadius: "4px",
  border: `1px solid ${COLORS.GRANITE}`,
}

export const cropFrameStyle = (crop: CropState, isDragging: boolean) => ({
  position: "absolute",
  top: crop.y,
  left: crop.x,
  width: crop.size,
  height: crop.size,
  border: `2px solid ${COLORS.WHITE}`,
  boxShadow: `0 0 0 ${CROP_OVERLAY_SPREAD_PX}px ${alpha(COLORS.BLACK, 0.6)}`,
  cursor: isDragging ? "grabbing" : "grab",
  touchAction: "none",
  zIndex: Z_INDEX_CROP_FRAME,
  "&::before, &::after": {
    content: '""',
    position: "absolute",
  },
  "&::before": {
    top: 0,
    left: "33.3%",
    width: "33.3%",
    height: "100%",
    borderLeft: ruleOfThirdsBorder,
    borderRight: ruleOfThirdsBorder,
  },
  "&::after": {
    top: "33.3%",
    left: 0,
    width: "100%",
    height: "33.3%",
    borderTop: ruleOfThirdsBorder,
    borderBottom: ruleOfThirdsBorder,
  },
})

export const resizeHandleStyle = {
  position: "absolute",
  bottom: RESIZE_HANDLE_OFFSET,
  right: RESIZE_HANDLE_OFFSET,
  width: RESIZE_HANDLE_SIZE,
  height: RESIZE_HANDLE_SIZE,
  bgcolor: COLORS.CERULEAN,
  border: `2px solid ${COLORS.WHITE}`,
  borderRadius: "50%",
  cursor: "nwse-resize",
  touchAction: "none",
  zIndex: Z_INDEX_RESIZE_HANDLE,
}
